(function(){
    // PRELOADER
    const ctr=document.querySelector('.pre-counter'),fill=document.querySelector('.pre-fill');
    let v=0;
    function tick(){
        if(v>=100){gsap.to('#preloader',{opacity:0,duration:.5,delay:.2,onComplete(){document.getElementById('preloader').style.display='none';boot()}});return}
        v+=Math.floor(Math.random()*10)+3;if(v>100)v=100;
        ctr.textContent=v;fill.style.width=v+'%';
        setTimeout(tick,Math.floor(Math.random()*60)+25);
    }
    tick();

    function boot(){
        // LENIS
        const lenis=new Lenis({duration:1.2,easing:t=>Math.min(1,1.001-Math.pow(2,-10*t))});
        lenis.on('scroll',ScrollTrigger.update);
        gsap.ticker.add(t=>lenis.raf(t*1000));
        gsap.ticker.lagSmoothing(0);

        // NAV
        gsap.to('nav',{y:0,duration:.5,ease:'power2.out',delay:.1});
        document.querySelector('nav').classList.add('show');

        // HERO TIMELINE — set initial hidden state via JS, then animate
        gsap.set('.hero-anim',{opacity:0,y:30});
        const ht=gsap.timeline({delay:.15});
        ht.to('.hero .pill-subtitle',{y:0,opacity:1,duration:.6,ease:'power3.out'})
          .to('.hero-title',{y:0,opacity:1,duration:.9,ease:'power3.out'},'-=.3')
          .to('.hero-desc',{y:0,opacity:1,duration:.6,ease:'power3.out'},'-=.4')
          .to('.hero-actions',{y:0,opacity:1,duration:.5,ease:'power3.out'},'-=.3')
          .to('.terminal',{y:0,opacity:1,duration:.6,ease:'power3.out'},'-=.3')
          .to('.hero-metrics',{y:0,opacity:1,duration:.6,ease:'power3.out'},'-=.3');

        // TERMINAL LINES
        gsap.utils.toArray('.terminal-body .line').forEach((l,i)=>{gsap.to(l,{opacity:1,duration:.25,delay:.6+(i*.35)})});

        // SCROLL ANIMS
        gsap.utils.toArray('.anim').forEach(el=>{gsap.to(el,{y:0,opacity:1,duration:.7,ease:'power3.out',scrollTrigger:{trigger:el,start:'top 88%',once:true}})});
        gsap.utils.toArray('.anim-left').forEach(el=>{gsap.to(el,{x:0,opacity:1,duration:.7,ease:'power3.out',scrollTrigger:{trigger:el,start:'top 85%',once:true}})});
        gsap.utils.toArray('.anim-right').forEach(el=>{gsap.to(el,{x:0,opacity:1,duration:.7,ease:'power3.out',scrollTrigger:{trigger:el,start:'top 85%',once:true}})});
        gsap.utils.toArray('.anim-scale').forEach(el=>{gsap.to(el,{scale:1,opacity:1,duration:.8,ease:'power3.out',scrollTrigger:{trigger:el,start:'top 85%',once:true}})});

        // CURSOR
        if(window.innerWidth>1024){
            const ball=document.getElementById('cursor-ball');
            let mx=0,my=0;
            document.addEventListener('mousemove',e=>{mx=e.clientX;my=e.clientY;if(!ball.classList.contains('on'))ball.classList.add('on')});
            gsap.ticker.add(()=>{gsap.to(ball,{x:mx-9,y:my-9,duration:.45,ease:'power2.out',overwrite:'auto'})});
            document.querySelectorAll('a,button,.bento-card,.store-card,.faq-q,.btn-pill,.nav-cta,.case-card').forEach(el=>{
                el.addEventListener('mouseenter',()=>ball.classList.add('big'));
                el.addEventListener('mouseleave',()=>ball.classList.remove('big'));
            });
        }
    }

    // FAQ
    document.querySelectorAll('.faq-q').forEach(q=>{q.addEventListener('click',()=>{const it=q.parentElement,w=it.classList.contains('open');document.querySelectorAll('.faq-item').forEach(i=>i.classList.remove('open'));if(!w)it.classList.add('open')})});

    // STORE FILTER
    document.querySelectorAll('.sf-btn').forEach(btn=>{btn.addEventListener('click',()=>{document.querySelectorAll('.sf-btn').forEach(b=>b.classList.remove('active'));btn.classList.add('active');const f=btn.dataset.filter;document.querySelectorAll('.store-card').forEach(c=>{if(f==='all')c.classList.remove('hidden');else c.classList.toggle('hidden',!(c.dataset.collection||'').includes(f))})})});
})();
